
import { CreditNote } from "../../classes"
const CreditNoteModule = {
  namespaced: true,
  state: {
    creditNote: null,
    creditNotes: [],
  },
  mutations: {
    setCreditNote(state, creditNote) {
      state.creditNote = creditNote || null
    },
    setCreditNotes(state, creditNotes) {
      state.creditNotes = creditNotes || []
    },
    addCreditNotes(state, creditNotes) {
      state.creditNotes = state.creditNotes.concat(creditNotes)
    }
  },
  actions: {
    createCreditNote: async ({ commit, rootGetters, dispatch }, formData) => {
      try {
        const result = await CreditNote.createCreditNote(formData);
        commit('setCreditNote', result)
        return result;
      } catch (err) {
        throw err;
      }
    },
    updateCreditNote: async ({ commit, rootGetters, dispatch }, formData) => {
      try {
        const result = await CreditNote.updateCreditNote(formData);
        commit('setCreditNote', result)
        return result;
      } catch (err) {
        throw err;
      }
    },
    getCreditNote: async ({ commit }, formData) => {
      try {
        var result = await CreditNote.getCreditNote(formData);
        commit('setCreditNote', result)
        return result;
      } catch (error) {
        throw error
      }
    },
    getCreditNotes: async ({ commit }, formData) => {
      try {
        var result = await CreditNote.getCreditNotes(formData);
        commit('setCreditNotes', result)
        return result;
      } catch (error) {
        throw error
      }
    },
    getCreditNotesBetweenDateByMarket: async ({ commit }, formData) => {
      try {
        var result = await CreditNote.getCreditNotesBetweenDateByMarket(formData);
        commit('setCreditNotes', result)
        return result;
      } catch (error) {
        throw error
      }
    },
    sendCreditNote: async ({ commit }, { id, date, dueDate }) => {
      try {
        var result = await CreditNote.sendCreditNote({ id, date, dueDate });
        return result;
      } catch (error) {
        throw error
      }
    },
    unsendCreditNote: async ({ commit }, { id }) => {
      try {
        var result = await CreditNote.unsendCreditNote({ id });
        return result;
      } catch (error) {
        throw error
      }
    },
    getCreditNoteData: async ({ commit }, formData) => {
      try {
        var result = await CreditNote.getCreditNoteData(formData);
        return result;
      } catch (error) {
        throw error
      }
    }
  },
  getters: {
    getCreditNotes: (state) => state.creditNotes,
  },
};
export default CreditNoteModule;
